import React from 'react'
import { useDrop } from 'react-dnd'
import { CellContainer, EmptyMessage } from '../../ProductionFlow/components-tests/DayCell/style'
import ProductionOrderCard from '../ProductionOrderCard'

function DayCell({ day, orders, moveProductionOrder }:any) {
    const [{ isOver }, drop ] = useDrop({
        accept: 'PRODUCTION_ORDER',
        drop: (item:any) => {
            if (item.day !== day) {
                moveProductionOrder(item.id, item.day, day)
            }
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver()
        }),
    })

    return (
        <CellContainer ref={drop}>
            {orders.length > 0 ? (
                orders.map((order:any) => (
                    <ProductionOrderCard 
                        key={order.id}
                        order={order}
                    />
                ))
            ) : (
                <EmptyMessage>Nenhuma ordem</EmptyMessage>
            )}
        </CellContainer>
    )
}

export default DayCell